
const Permission = {
    mounted: (el, binding) => {
        try {
            const btns = JSON.parse(localStorage.getItem('authBtns') || '[]');
            const isExistAuth = btns?.find(item => item.menuCode === binding.value);
            if (!isExistAuth) {
                el.parentNode.removeChild(el);
            }
        } catch (e) {
            console.log(e);
        }
    }
};

export {
    Permission
};
